module.exports = __webpack_public_path__ + "img/skull_bj.6baaecf6.png";